/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import * as THREE from 'three';
import * as ThreeMeshUI from 'three-mesh-ui';

import { LeaderboardComponent } from '../../components/MultiplayerComponents';
import { System } from 'ecsy';
import { THREEGlobalComponent } from '../../components/THREEGlobalComponent';
import { getOnlyEntity } from '../../utils/entityUtils';

export class LeaderboardSystem extends System {
	init() {
		this.threeGlobal = null;
		this.leaderboardBlock = null;
		this.statsText = null;
	}

	execute() {
		if (!this.threeGlobal) {
			const entity = getOnlyEntity(this.queries.threeGlobal, false);
			if (entity) {
				this.threeGlobal = entity.getComponent(THREEGlobalComponent);
			}
		}

		if (!this.threeGlobal) return;
		const entity = getOnlyEntity(this.queries.leaderboard, false);
		if (!entity) return;

		if (!this.leaderboardBlock) {
			this._initLeaderboardUI();
		}

		this._updateLeaderboardUI(entity.getComponent(LeaderboardComponent));
	}

	_initLeaderboardUI() {
		this.leaderboardBlock = new ThreeMeshUI.Block({
			width: 2,
			height: 1.5,
			padding: 0.1,
			flexDirection: 'column',
			justifyContent: 'start',
			alignItems: 'center',
			backgroundColor: new THREE.Color(0x111111),
			backgroundOpacity: 0.8,
			borderRadius: 0.1,
		});

		const title = new ThreeMeshUI.Text({
			content: 'GLOBAL VISITORS',
			fontSize: 0.15,
			fontFamily: 'assets/fonts/Roboto-Bold-48.json',
			fontTexture: 'assets/fonts/Roboto-Bold-48.png',
		});
		this.leaderboardBlock.add(title);

		this.statsText = new ThreeMeshUI.Text({
			content: 'Loading stats...',
			fontSize: 0.08,
			fontFamily: 'assets/fonts/Roboto-Regular-48.json',
			fontTexture: 'assets/fonts/Roboto-Regular-48.png',
		});
		this.leaderboardBlock.add(this.statsText);

		// Position the leaderboard in the world (e.g., near the start)
		this.leaderboardBlock.position.set(0, 1.5, -3);
		this.threeGlobal.scene.add(this.leaderboardBlock);
	}

	_updateLeaderboardUI(leaderboard) {
		if (!this.statsText) return;

		let countryList = Object.entries(leaderboard.visitorCountries)
			.sort((a, b) => b[1] - a[1])
			.slice(0, 5)
			.map(([country, count]) => `${country}: ${count}`)
			.join('\n');

		const content = `Total Visitors: ${leaderboard.totalVisitors}\n\nTop Countries:\n${countryList}`;
		this.statsText.set({ content });
	}
}

LeaderboardSystem.queries = {
	threeGlobal: { components: [THREEGlobalComponent] },
	leaderboard: { components: [LeaderboardComponent] },
};
